import UrlPattern from "url-pattern"

export const getUrl = (pattern, params = {}) => {
    const base = (process.env.REACT_APP_API_ENDPOINT || '').replace(/\/$/, '')
    const path = (new UrlPattern(pattern)).stringify(params)

    return `${base}${path.startsWith('/') ? '' : '/'}${path}`
}